var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.content.type === 1 ? _c('div', {
    staticClass: "message-form"
  }, [_c('div', {
    staticClass: "message-form"
  }, [_c('FormBranch', {
    attrs: {
      "title": _vm.content.header,
      "list": _vm.content.items,
      "selectedContent": _vm.content.selected && _vm.content.selected.content
    },
    on: {
      "input-click": _vm.handleContentListItemClick
    }
  })], 1)]) : _c('div', {
    staticClass: "message-form-input"
  }, [_c('FormInput', {
    attrs: {
      "title": _vm.content.header,
      "selectedContent": _vm.content.selected && _vm.content.selected.content
    },
    on: {
      "input-submit": _vm.handleFormSaveInputSubmit
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }